module.exports = __webpack_public_path__ + "img/20190813155851897.1336da49.png";